import React, { memo } from 'react';
import { HighchartsReact } from 'investira.react.charts';
import { formats } from 'investira.sdk';
import { shortname } from '../../../../utils/typo';

const CarteirasChart = memo(props => {
  const carteiras = Array.isArray(props.data) ? props.data : props.data?.carteiras || [];

  const xTotalFinanceiro = carteiras.reduce((xAcc, xItem) => {
    return xAcc + (xItem.financeiro || 0);
  }, 0);

  const xCarteiras = carteiras.map(xValue => {
    const xPercentual = xTotalFinanceiro ? (xValue.financeiro / xTotalFinanceiro) * 100 : 0;

    return {
      name: String(xValue.carteira).toUpperCase(),
      y: xValue.financeiro || 0,
      dataLabels: {
        color: '#FFFFFF'
      },
      metadata: {
        data_posicao: formats.formatDate(xValue.data || xValue.data_posicao, 'DD/MM/YYYY'),
        status_posicao: Boolean(xValue.aberta) ? 'Aberta' : 'Fechada',
        percentual: formats.formatNumber(xPercentual, 2),
        financeiro: formats.formatNumber(xValue.financeiro || 0, 2, true, true),
        quantidade: formats.formatNumber(xValue.quantidade, 6, true),
        quantidade_ativos: xValue.quantidade_ativos
      }
    };
  });

  const xOptions = {
    chart: {
      type: 'pie',
      height: '350px'
    },
    title: false,
    plotOptions: {
      pie: {
        innerSize: '50%',
        borderColor: '#2e2e46',
        borderWidth: 2,
        shadow: false,
        center: ['50%', '50%'],
        dataLabels: {
          enabled: true,
          formatter: function () {
            return `<span style="color: #FFFFFF; text-decoration: none;">${shortname(
              this.point.name,
              25
            )}</span>`;
          },
          style: {
            color: '#FFFFFF',
            textOutline: 'none',
            zIndex: 1
          }
        }
      }
    },
    tooltip: {
      useHTML: true,
      style: {
        zIndex: 1000
      },
      pointFormat: `Última Posição: <b>{point.metadata.data_posicao}</b><br>
                    Posição: <b>{point.metadata.status_posicao}</b><br>
                    Quantidade: <b>{point.metadata.quantidade}</b><br>
                    Financeiro: <b>{point.metadata.financeiro}</b><br>
                    Part.: <b>{point.metadata.percentual}%</b><br>
                    Quantidade de Ativos: <b>{point.metadata.quantidade_ativos}</b>`
    },
    series: [
      {
        name: 'Carteira',
        colorByPoint: true,
        data: xCarteiras,
        dataLabels: {
          color: '#ffffff',
          enabled: true,
          style: {
            fontSize: '11px' // Reduz o tamanho da fonte
          },
          formatter: function () {
            const xCurrentPercentual = xTotalFinanceiro ? this.y / xTotalFinanceiro : 0;
            // Mostra label apenas se o valor for maior que 5% do total
            if (xCurrentPercentual > 0.05) {
              return shortname(this.key, 25);
            }
            return null;
          }
        }
      }
    ],
    drilldown: {
      // series: xAtivosTipo,
      breadcrumbs: {
        style: {
          color: '#FFFFFF',
          fill: '#FFFFFF' // Text color
        },
        buttonTheme: {
          style: {
            color: '#00dfa8' // Text color
          },
          states: {
            hover: {
              fill: 'none' // Cor de fundo ao passar o mouse
            },
            select: {
              style: {
                color: '#FFFFFF',
                cursor: 'default' // Cor do texto quando selecionado
              },
              fill: 'none'
            }
          }
        }
      }
    }
  };

  return <HighchartsReact options={xOptions} />;
});

export default CarteirasChart;
